import React from "react"
import {
  siAffinitydesigner,
  siAffinityphoto,
  // siAftereffects,
  siAsana,
  // siAzuredevops,
  siBabel,
  siBasecamp,
  siBlender,
  siBulma,
  siCss,
  siDigitalocean,
  siDocker,
  // siDynamics365,
  siEslint,
  siFigma,
  siGatsby,
  siGoogleanalytics,
  siGooglemaps,
  siGraphql,
  siGrunt,
  siGulp,
  siHtml5,
  siHubspot,
  // siIllustrator,
  siJavascript,
  siJquery,
  siJson,
  siMarkdown,
  siMongodb,
  siMysql,
  siNetlify,
  siNextdotjs,
  siNodedotjs,
  siNotion,
  siPaypal,
  // siPhotoshop,
  siPhp,
  siPostcss,
  siPostman,
  // siPremiere,
  siPrettier,
  siReact,
  siSalesforce,
  siSass,
  siSentry,
  siSketch,
  siSlack,
  siStripe,
  siStyledcomponents,
  siSvelte,
  siTailwindcss,
  siVercel,
  // siVisualstudiocode,
  siVuedotjs,
  siWebpack,
  siWordpress,
  siWpengine,
} from "simple-icons"

function listFormat(icon, site) {
  // console.log("listFormat", icon, site)
  return {
    title: icon.title,
    hex: icon.hex,
    svg: icon.svg,
    site,
  }
}

const listCMSs = [
  listFormat(siGatsby, "https://www.gatsbyjs.org"),
  listFormat(siWordpress, "https://wordpress.org"),
]
const listAPIs = [
  listFormat(siGooglemaps, "https://cloud.google.com/maps-platform/"),
  listFormat(siPaypal, "https://developer.paypal.com/classic-home/"),
  listFormat(siStripe, "https://stripe.com/docs/api/"),
]
const listLangs = [
  listFormat(siCss, "https://developer.mozilla.org/en-US/docs/Web/CSS/"),
  listFormat(
    siHtml5,
    "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/"
  ),
  listFormat(
    siJavascript,
    "https://developer.mozilla.org/en-US/docs/Web/javascript/"
  ),
  listFormat(siJson, "https://www.json.org/json-en.html"),
  listFormat(siMarkdown, "https://www.markdownguide.org"),
  listFormat(siPhp, "https://www.php.net"),
  listFormat(siNodedotjs, "https://nodejs.org/en/"),
  listFormat(siGraphql, "https://graphql.org"),
]
const listJS = [
  listFormat(siVuedotjs, "https://vuejs.org"),
  listFormat(siSvelte, "https://svelte.dev"),
  listFormat(siReact, "https://reactjs.org"),
  listFormat(siNextdotjs, "https://nextjs.org"),
  listFormat(siJquery, "https://jquery.com"),
]
const listCSS = [
  listFormat(siTailwindcss, "https://tailwindcss.com"),
  listFormat(siStyledcomponents, "https://styled-components.com"),
  listFormat(siBulma, "https://bulma.io"),
  listFormat(siSass, "https://sass-lang.com"),
]
const listBuilds = [
  listFormat(siWebpack, "https://webpack.js.org"),
  listFormat(siGulp, "https://gulpjs.com"),
  listFormat(siGrunt, "https://gruntjs.com"),
  listFormat(siBabel, "https://babeljs.io"),
  listFormat(siEslint, "https://eslint.org"),
  listFormat(siPostcss, "https://postcss.org"),
  listFormat(siPrettier, "https://prettier.io"),
]
const listHosts = [
  listFormat(siNetlify, "https://www.netlify.com/"),
  listFormat(siDigitalocean, "https://www.digitalocean.com/"),
  listFormat(siWpengine, "https://wpengine.com/"),
  listFormat(siVercel, "https://vercel.com/"),
  // listFormat(____, "https://azure.microsoft.com/en-us/services/devops/"),
]
const listDevTools = [
  // listFormat(____, "https://code.visualstudio.com"),
  listFormat(siMysql, "https://www.mysql.com"),
  listFormat(siMongodb, "https://www.mongodb.com"),
  listFormat(siDocker, "https://www.docker.com"),
  listFormat(siPostman, "https://www.postman.com"),
  listFormat(siSentry, "https://sentry.io"),
  listFormat(siGoogleanalytics, "https://analytics.google.com/analytics/web/"),
]
const listGraphics = [
  listFormat(siFigma, "https://www.figma.com"),
  listFormat(siAffinitydesigner, "https://affinity.serif.com/en-gb/designer/"),
  listFormat(siAffinityphoto, "https://affinity.serif.com/en-gb/photo/"),
  listFormat(siSketch, "https://www.sketch.com"),
  // listFormat(____, "https://www.adobe.com"), // photoshop
  // listFormat(____, "https://www.adobe.com"), // illustrator
  // listFormat(____, "https://www.adobe.com"), // aftereffects
  // listFormat(____, "https://www.adobe.com"), // premier
  listFormat(siBlender, "https://www.blender.org"),
]
const listOffice = [
  listFormat(siNotion, "https://www.notion.so"),
  listFormat(siAsana, "https://asana.com"),
  listFormat(siBasecamp, "https://basecamp.com"),
  listFormat(siHubspot, "https://www.hubspot.com"),
  listFormat(siSalesforce, "https://www.salesforce.com"),
  listFormat(siSlack, "https://slack.com"),
  // listFormat(____, "https://dynamics.microsoft.com/en-us/"),
]

function UsesList({ name, list }) {
  return (
    <div class="group">
      <h3>{name}</h3>

      <ul>
        {list.map(p => (
          <li>
            <a
              href={p.site}
              target="_blank"
              rel="noopener noreferrer"
              style={{ "--tint": `#${p.hex}` }}
            >
              <span>{p.title}</span>
              <div dangerouslySetInnerHTML={{ __html: p.svg }} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default () => (
  <section id="uses" className="py-32 px-8 bg-cove-500 text-white text-center">
    <div className="container mx-auto">
      <div className="pb-16 max-w-lg mx-auto">
        <h2>experienced with</h2>
        <p>
          Over the years I've built highly optimized, user-focused, and large
          scale SaaS websites. These are the various technologies, frameworks,
          and all the fantastic tools that I've used since.
        </p>
      </div>

      <div className="dev-icons">
        <UsesList name="Content Management" list={listCMSs} />
        <UsesList name="APIs" list={listAPIs} />
        <UsesList name="Languages" list={listLangs} />
        <UsesList name="JavaScript Frameworks" list={listJS} />
        <UsesList name="CSS Frameworks" list={listCSS} />
        <UsesList name="Build Tools" list={listBuilds} />
        <UsesList name="Hosting" list={listHosts} />
        <UsesList name="Development Tools" list={listDevTools} />
        <UsesList name="Graphic Design" list={listGraphics} />
        <UsesList name="Office" list={listOffice} />
      </div>
    </div>
  </section>
)
